import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { formInjectionKey as v } from "./context.js";
import { formatLength as c } from "../../_utils/css/format-length.js";
import L from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/get.js";
import { inject as h, computed as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as R } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function y(n) {
  const e = h(v, null);
  return {
    mergedSize: t(() => n.size !== void 0 ? n.size : (e == null ? void 0 : e.props.size) !== void 0 ? e.props.size : "medium")
  };
}
function M(n) {
  const e = h(v, null), l = t(() => {
    const {
      labelPlacement: r
    } = n;
    return r !== void 0 ? r : e != null && e.props.labelPlacement ? e.props.labelPlacement : "top";
  }), o = t(() => l.value === "left" && (n.labelWidth === "auto" || (e == null ? void 0 : e.props.labelWidth) === "auto")), s = t(() => {
    if (l.value === "top")
      return;
    const {
      labelWidth: r
    } = n;
    if (r !== void 0 && r !== "auto")
      return c(r);
    if (o.value) {
      const b = e == null ? void 0 : e.maxChildLabelWidthRef.value;
      return b !== void 0 ? c(b) : void 0;
    }
    if ((e == null ? void 0 : e.props.labelWidth) !== void 0)
      return c(e.props.labelWidth);
  }), m = t(() => {
    const {
      labelAlign: r
    } = n;
    if (r)
      return r;
    if (e != null && e.props.labelAlign)
      return e.props.labelAlign;
  }), i = t(() => {
    var r;
    return [(r = n.labelProps) === null || r === void 0 ? void 0 : r.style, n.labelStyle, {
      width: s.value
    }];
  }), u = t(() => {
    const {
      showRequireMark: r
    } = n;
    return r !== void 0 ? r : e == null ? void 0 : e.props.showRequireMark;
  }), f = t(() => {
    const {
      requireMarkPlacement: r
    } = n;
    return r !== void 0 ? r : (e == null ? void 0 : e.props.requireMarkPlacement) || "right";
  }), a = R(!1), d = R(!1), g = t(() => {
    const {
      validationStatus: r
    } = n;
    if (r !== void 0)
      return r;
    if (a.value)
      return "error";
    if (d.value)
      return "warning";
  }), p = t(() => {
    const {
      showFeedback: r
    } = n;
    return r !== void 0 ? r : (e == null ? void 0 : e.props.showFeedback) !== void 0 ? e.props.showFeedback : !0;
  }), w = t(() => {
    const {
      showLabel: r
    } = n;
    return r !== void 0 ? r : (e == null ? void 0 : e.props.showLabel) !== void 0 ? e.props.showLabel : !0;
  });
  return {
    validationErrored: a,
    validationWarned: d,
    mergedLabelStyle: i,
    mergedLabelPlacement: l,
    mergedLabelAlign: m,
    mergedShowRequireMark: u,
    mergedRequireMarkPlacement: f,
    mergedValidationStatus: g,
    mergedShowFeedback: p,
    mergedShowLabel: w,
    isAutoLabelWidth: o
  };
}
function F(n) {
  const e = h(v, null), l = t(() => {
    const {
      rulePath: i
    } = n;
    if (i !== void 0)
      return i;
    const {
      path: u
    } = n;
    if (u !== void 0)
      return u;
  }), o = t(() => {
    const i = [], {
      rule: u
    } = n;
    if (u !== void 0 && (Array.isArray(u) ? i.push(...u) : i.push(u)), e) {
      const {
        rules: f
      } = e.props, {
        value: a
      } = l;
      if (f !== void 0 && a !== void 0) {
        const d = L(f, a);
        d !== void 0 && (Array.isArray(d) ? i.push(...d) : i.push(d));
      }
    }
    return i;
  }), s = t(() => o.value.some((i) => i.required)), m = t(() => s.value || n.required);
  return {
    mergedRules: o,
    mergedRequired: m
  };
}
export {
  M as formItemMisc,
  F as formItemRule,
  y as formItemSize
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/utils.js
// module id = 1648
// module chunks = 41